import { Box } from '@mui/material'
import { ReactComponent as ErrorLogo } from 'assets/error_logo.svg'
import { ReactComponent as SmartFarmLogo } from 'assets/smart_farm_logo.svg'
import { Link, useRouteError } from 'react-router-dom'
import { COLORS } from 'styles/colors'
import { ButtonUI } from 'ui/buttons/ButtonUI'
import { TypographyHeader } from 'ui/typography/TypographyHeader'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'

export const ErrorBoundaryPage = () => {
	const error = useRouteError()

	const reloadPage = () => {
		window.location.reload()
	}

	return (
		<Box
			sx={{
				padding: '24px 40px',
				width: '100vw',
				height: '100vh',
				background: '#f7f7f7',
				position: 'relative',
			}}
		>
			<Link to={'/feed'}>
				<SmartFarmLogo fill='#5222D0' />
			</Link>
			<Box
				sx={{
					position: 'absolute',
					top: '20%',
					left: '30%',
					width: '586px',
					height: '70%',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<ErrorLogo />
					<TypographyHeader sx={{ marginTop: '40px' }}>
						Что-то пошло не так
					</TypographyHeader>
					<TypographyPrimary sx={{ marginTop: '16px', textAlign: 'center' }}>
						Мы уже устраняем неисправность, попробуйте обновить страницу или
						вернуться на
						<Link
							to={'/feed'}
							style={{
								fontWeight: '400',
								fontSize: '14px',
								color: COLORS.main,
								textDecoration: 'underline',
								textUnderlineOffset: '3px',
							}}
							rel='noreferrer'
						>
							главную страницу
						</Link>{' '}
						через некоторое время. Приносим извинения за временные неудобства.
					</TypographyPrimary>
					<ButtonUI
						onClick={reloadPage}
						disableRipple
						sx={{ width: '400px', mt: '32px' }}
					>
						Обновить
					</ButtonUI>

					<TypographySecondary14 sx={{ marginTop: '40px' }}>
						Если ошибка сохраняется
						<a
							target='_blank'
							href='https://smartfarm.vision/help'
							style={{
								fontWeight: '400',
								fontSize: '14px',
								color: COLORS.main,
								textDecoration: 'underline',
								textUnderlineOffset: '3px',
							}}
							rel='noreferrer'
						>
							свяжитесь с нами
						</a>
					</TypographySecondary14>
				</Box>
			</Box>
			<TypographySecondary
				sx={{ position: 'absolute', bottom: '24px', right: '24px' }}
			>
				{error instanceof Error ? error.message : 'Unknown error'}
			</TypographySecondary>
		</Box>
	)
}
